var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplatesWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.243,
    viewBox: "0 0 18 18.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160676",
    "data-name": "Group 160676",
    transform: "translate(-320 -367.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160594",
    "data-name": "Group 160594",
    transform: "translate(320 368)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1121",
    "data-name": "Rectangle 1121",
    width: 18,
    height: 18,
    transform: "translate(0)",
    fill: "#ffe4e4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3240",
    "data-name": "Group 3240",
    transform: "translate(5.887 0.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M19.9,6.27V5.653a1.877,1.877,0,0,0-1.7-1.885c-.321-.025-.642-.051-.964-.068",
    transform: "translate(-9.573 -2.348)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M11.325,3.71a1.878,1.878,0,0,0-.085.566.642.642,0,0,0,.642.642h3.863a.642.642,0,0,0,.642-.642A1.8,1.8,0,0,0,16.3,3.71",
    transform: "translate(-8.645 -2.349)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M11.33,3.461A1.93,1.93,0,0,1,13.173,2.1h1.285a1.94,1.94,0,0,1,1.851,1.361",
    transform: "translate(-8.659 -2.1)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M10.833,3.71c-.321.017-.642.042-.964.068a1.877,1.877,0,0,0-1.7,1.885V7.505",
    transform: "translate(-8.17 -2.349)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 0.482,
    cy: 0.482,
    r: 0.482,
    transform: "translate(15.734 6.035)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 3.221,
    transform: "translate(6.546 14.04)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M15.81,17.744h1.936a1.935,1.935,0,0,0,1.936-1.936V11.59",
    transform: "translate(-3.465 -3.061)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M7.463,8.19h-2.9a.963.963,0,0,0-.964.964v9.662a.963.963,0,0,0,.964.964h8.394a.963.963,0,0,0,.964-.964V9.162a.963.963,0,0,0-.964-.964H7.463Z",
    transform: "translate(-1.576 -2.535)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x2: 3.221,
    transform: "translate(6.529 9.763)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M6.64,13.05Z",
    transform: "translate(-2.046 -3.287)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M6.64,18.1Z",
    transform: "translate(-2.046 -4.068)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesWhiteIcon);
export default __webpack_public_path__ + "static/media/templates-white-icon.7edfc62a5f046863d0f3103dad4acdcb.svg";
export { ForwardRef as ReactComponent };